import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ChatModel } from '../model/chat-model';

@Injectable({
  providedIn: 'root',
})
export class ChatTabService {
  private readonly _chatName$ = new BehaviorSubject<string>('');
  readonly chatName$ = this._chatName$.asObservable();

  private readonly _conversationCount$ = new BehaviorSubject<number>(0);
  readonly conversationCount$ = this._conversationCount$.asObservable();

  private readonly _firstMessageTime$ = new BehaviorSubject<number>(0);
  readonly firstMessageTime$ = this._firstMessageTime$.asObservable();

  private readonly _lastMessageDate$ = new BehaviorSubject<Date>(new Date());
  readonly lastMessageDate$ = this._lastMessageDate$.asObservable();

  set chatName(chatName: string) {
    this._chatName$.next(chatName);
  }

  set conversationCount(conversationCount: number) {
    if (conversationCount !== this._conversationCount$.value) {
      this._conversationCount$.next(conversationCount);
    }
  }

  set firstMessageTime(firstMessageTime: number) {
    this._firstMessageTime$.next(firstMessageTime);
  }

  set lastMessageDate(date: Date) {
    if (!this._lastMessageDate$.value && this._lastMessageDate$.value > date) {
      return;
    }
    this._lastMessageDate$.next(date);
  }

  /**
   * Get the last message sent by a customer in the list of the available chat conversations
   * @param {Array<ChatModel>} chatList available chat conversations
   */
  computeLastMessageDateForAllChats(chatList: Array<ChatModel>): void {
    const lastMessageDate = chatList.reduce((prev: number, chat: ChatModel) => {
      if (chat.tab.lastMessageTime && chat.tab.lastMessageTime > prev) {
        return chat.tab.lastMessageTime;
      } else {
        return prev;
      }
    }, 0);
    this._lastMessageDate$.next(new Date(lastMessageDate));
  }
}
